import {
    useGelScrollContentToTop
} from '@tal-gel/components';

export function GelScrollOnMount() {
  useGelScrollContentToTop(); // runs on mount
  return null;
}
